// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1764017688618
      var cssReload = require("C:/Users/soiko/Documents/Projects/game/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  